import type { VoidFunctionComponent } from 'react';

import Icon, { icons } from '../../Icon';
import Link from '../../Link/Link';

import styles from './actions.module.less';

type Props = {
  url: string;
};

/**
 * Generic component that renders an expand icon button for opening content in full page view.
 *
 * This component is designed to be used in drawer button slots to provide users with
 * a way to navigate from a drawer view to the corresponding full page view. It opens
 * the target URL in a new tab to preserve the current context.
 *
 * @param props - Component props
 * @param props.url - The full page URL to navigate to when clicked
 *
 * @example
 * ```typescript
 * // In a drawer's buttonsSlot
 * <OpenInFullPage url="/projects/123/issues/456" />
 *
 * // With computed URL
 * const fullPageUrl = `/snippets/${snippetId}`;
 * <OpenInFullPage url={fullPageUrl} />
 * ```
 */
const OpenInFullPage: VoidFunctionComponent<Props> = ({ url }) => {
  return (
    <Link
      to={url}
      className={styles.openInFullPageLink}
      openInNewTab
    >
      <Icon icon={icons.expand} />
    </Link>
  );
};

export default OpenInFullPage;
